import PermitsReportContainer from "@/Reports/PermitsReportContainer.vue";

export default [
  {
    path: "/permits",
    name: "PermitsReportContainer",
    component: PermitsReportContainer,
    meta: {
      permissionRoles: ["jobs"]
    }
  }
];
